/**
 * toastBridge
 *
 * 목적:
 * - 화면마다 `useToast()`를 import/호출하지 않고, 공통 showAlert/showConfirm을 "브릿지"로 제공
 * - Layout(또는 최상위 컴포넌트)에서 1회 setToastHandlers로 주입
 *
 * 사용 방법:
 * 1) Layout.js에서:
 *    const { showAlert, showConfirm } = useToast();
 *    setToastHandlers({ showAlert, showConfirm });
 *
 * 2) 각 화면에서는:
 *    import { showAlert, showConfirm } from 'utils/toastBridge';
 */

let _showAlert = null;
let _showConfirm = null;

export const setToastHandlers = ({ showAlert, showConfirm } = {}) => {
  _showAlert = typeof showAlert === 'function' ? showAlert : null;
  _showConfirm = typeof showConfirm === 'function' ? showConfirm : null;
};

export const showAlert = (message, type = 'info', duration = 3000) => {
  if (_showAlert) {
    return _showAlert(message, type, duration);
  }
  // 초기화 전 호출 대비 fallback
  if (typeof window !== 'undefined') {
    window.alert(typeof message === 'string' ? message : JSON.stringify(message, null, 2));
  }
  return undefined;
};

export const showConfirm = (message, type = 'info', confirmText = '확인', cancelText = '취소') => {
  if (_showConfirm) {
    return _showConfirm(message, type, confirmText, cancelText);
  }
  // 초기화 전 호출 대비 fallback
  if (typeof window !== 'undefined') {
    return Promise.resolve(window.confirm(typeof message === 'string' ? message : JSON.stringify(message, null, 2)));
  }
  return Promise.resolve(false);
};

